React = require 'react'
Auth = require 'db/auth'
Util = require 'lib/util'
t = require('views/internal/recup-with-helpers')('billing')
f = require 'effing'
track = require 'debug/track'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'

STEP_SHOW_FEATURES = 1
STEP_SHOW_SURVEY = 2

module.exports = class extends React.Component
  displayName: 'CancelFlowComponent'

  constructor: (props) ->
    super(props)

    @state = {
      isGold: @props.type is 'gold'
      isCancelling: @props.initialIsCancelling
      cancellingStep: STEP_SHOW_FEATURES
      features: []
    }

  componentDidMount: ->
    @fetchFeatures((features) => @setState({ features }))

  fetchFeatures: (cb) =>
    idOrg = @props.id
    orderedFeatures =
      dynamic: [
        (org) ->
          key = 'dynamic-feature-unlimited-powerups'
          if (count = org.boardList.filter((b) -> b.powerUpsCount() > 1).length)
            { key, data: { count } }
        (org) ->
          key = 'dynamic-feature-deactivate-users'
          if (count = org.get('memberships').filter((m) -> m.deactivated).length)
            { key, data: { count } }
        (org) ->
          key = 'dynamic-feature-observers'
          if (count = org.boardList.filter((b) -> b.get('memberships').some((m) -> m.memberType is 'observer')).length)
            { key, data: { count } }
        (org) ->
          key = 'dynamic-feature-collections'
          if (count = org.boardList.filter((b) -> b.get('idTags').length).length)
            { key, data: { count } }
        (org) ->
          key = 'dynamic-feature-invitation-restrictions'
          if (org.boardList.some((b) -> b.getInvitePerm() isnt 'members'))
            { key }
        (org) ->
          key = 'dynamic-feature-visibility-restrictions'
          if (org.boardList.some((b) -> b.getPermLevel() is 'org'))
            { key }
        (org) ->
          key = 'dynamic-feature-private-boards'
          if (count = org.boardList.filter((b) -> b.isPrivate()).length)
            { key, data: { count } }
        (org) ->
          key = 'dynamic-feature-bulk-export'
          if (org.get('exports')?.length)
            { key }
      ]
      static: [
        'static-feature-unlimited-powerups'
        'static-feature-bigger-attachments'
        'static-feature-priority-email-support'
        'static-feature-board-export'
      ]
      gold: [
        'gold-feature-powerups'
        'gold-feature-bigger-attachments'
        'gold-feature-custom-backgrounds'
        'gold-feature-saved-searches'
      ]

    if @state.isGold
      cb(orderedFeatures.gold.map((key) -> { key }))
    else
      ModelLoader.loadBCFeatures(idOrg)
        .then((org) ->
          cb(
            orderedFeatures.dynamic
              .map((featureFunc) -> featureFunc(org))
              .filter((f) -> f)
              .concat(orderedFeatures.static.map((key) -> { key }))
              .slice(0, 4)
          )
        )

  render: t.renderable ->
    { productName, cancelProduct, isModule, isDeleting, willExpire, type, paysWithPurchaseOrder, belongsToRealEnterprise } = @props
    { isCancelling, cancellingStep, features, isGold } = @state

    startCancel = =>
      track('Organization View', 'Billing Page', 'Open Cancel Business Class Dialog')
      @setState isCancelling: true
    advanceCancel = =>
      if !isDeleting
        @setState cancellingStep: STEP_SHOW_SURVEY
      cancelProduct()
    cancelCancel = =>
      @setState(
        cancellingStep: STEP_SHOW_FEATURES
        isCancelling: false
      )

    t.div
      class: t.classify
        'window-module': isModule
        '.u-gutter': isModule
    , ->
      if !isCancelling && isDeleting
        if !willExpire
          if belongsToRealEnterprise
            t.b startCancel, '.quiet.dark-hover', ->
              t.format 'delete-this-organization'
          else if paysWithPurchaseOrder
            t.span '.quiet', ->
              t.format 'need-to-delete-team-contact-account-manager-or-sales-first'
          else
            t.span '.quiet', ->
              t.format 'need-to-delete-team-cancel-bc-first'
      else if !isCancelling
        if !willExpire
          t.b startCancel, '.quiet.dark-hover', ->
            t.icon 'close'
            t.text ' '
            t.format 'cancel-productname-ellipsis', { productName }
      else
        t.div ->
          t.div '.cancel-flow-overlay', onClick: cancelCancel, ->
            t.div '.cancel-flow-dialog-wrapper', ->
              t.div ".cancel-flow-dialog.#{type}", onClick: Util.stopPropagation, ->
                t.span '.icon-lg.icon-close.cancel-flow-overlay-close-icon', onClick: cancelCancel
                t.img '.cancel-flow-logo', { src: (
                  if isGold
                    require('images/trello-gold-logo-gold@2x.png')
                  else
                    require('images/business-class-logo-white@2x.png')
                ) }
                t.div '.cancel-flow-content', ->
                  if cancellingStep is STEP_SHOW_FEATURES
                    t.p '.cancel-flow-bold', ->
                      t.text ' '
                      '😭 '
                      t.format 'cancel-pre-features', { productName }
                    t.ul ->
                      features.map(({ key, data }) ->
                        t.li -> t.format key, data
                      )
                    t.p ->
                      t.format 'cancel-post-features'
                    t.div '.cancel-flow-buttons', ->
                      t.button '.button.primary.cancel-flow-keep', onClick: cancelCancel, ->
                        t.format(
                          if isDeleting then 'cancel-delete-keep' else 'cancel-keep'
                          { productName }
                        )
                      t.button '.button.cancel-flow-confirm', onClick: advanceCancel, ->
                        t.format(if isDeleting then 'cancel-delete-switch' else 'cancel-switch')
                  else if cancellingStep is STEP_SHOW_SURVEY
                    t.p '.cancel-flow-bold', ->
                      t.format 'cancel-sorry-to-see-you-go'
                    t.div ->
                      t.format 'cancel-tell-us-about-your-experience'
                      t.text ' '
                      t.a { href: 'https://trello.typeform.com/to/hiuX7c?id=' + Auth.me().id, target: '_blank' }, ->
                        t.format 'cancel-take-our-survey'



// WEBPACK FOOTER //
// ./app/scripts/views/billing/cancel-flow-component.coffee